const checkSpecsIsLegal = (cargoThickness, cargoWidth, cargoLength) => {
    let strTemp = "0123456789";
    let j = -1;
    let k = -1;
    let l = -1;

    if (cargoThickness != null) {
        let doubleTemp = "0123456789.";
        let dotCount = 0;

        for (let i = 0; i < cargoThickness.length; i++) {
            j = doubleTemp.indexOf(cargoThickness.charAt(i));

            if (j == -1) {
                return false;
            }

            if (cargoThickness.charAt(i).indexOf(".") != -1) {
                dotCount++;

                if (dotCount > 1) {
                    return false;
                }
            }
        }
    }

    if (cargoWidth != null) {
        for (let i = 0; i < cargoWidth.length; i++) {
            k = strTemp.indexOf(cargoWidth.charAt(i));

            if (k == -1) {
                return false;
            }
        }
    }

    if (cargoLength != null) {
        for (let i = 0; i < cargoLength.length; i++) {
            l = strTemp.indexOf(cargoLength.charAt(i));
            let a = 0

            if (l == -1) {
                if (cargoLength == 'c' || cargoLength == 'C') {
                    a = a + 1
                } else {
                    return false;
                }
            }
        }
    }

    return true;
}

const checkSpecsIsSplit = (cargoThickness, cargoWidth, cargoLength) => {
    let strTemp = "0123456789";
    let j = -1;
    let k = -1;
    let l = -1;

    if (cargoThickness != null) {
        if (cargoThickness.indexOf('-') != -1) {
            if (cargoThickness.split('-').length != 2) {
                return false
            } else {
                let start = cargoThickness.split('-')[0]
                let end = cargoThickness.split('-')[1]
                if (start != '') {
                    let isThicknessIsLegal = checkSpecsIsLegal(start, 1, 1)
                    if (!isThicknessIsLegal) {
                        return false
                    } else {
                        let isThicknessLengthIsLegal = checkSpecsLengthIsLegal(start, 1, 1)
                        if (!isThicknessLengthIsLegal) {
                            return false
                        }
                    }
                } else {
                    return false
                }

                if (end != '') {
                    let isThicknessIsLegal = checkSpecsIsLegal(end, 1, 1)
                    if (!isThicknessIsLegal) {
                        return false
                    } else {
                        let isThicknessLengthIsLegal = checkSpecsLengthIsLegal(end, 1, 1)
                        if (!isThicknessLengthIsLegal) {
                            return false
                        }
                    }
                } else {
                    return false
                }
            }
        } else {
            let doubleTemp = "0123456789.";
            let dotCount = 0;

            for (let i = 0; i < cargoThickness.length; i++) {
                j = doubleTemp.indexOf(cargoThickness.charAt(i));

                if (j == -1) {
                    return false;
                }

                if (cargoThickness.charAt(i).indexOf(".") != -1) {
                    dotCount++;

                    if (dotCount > 1) {
                        return false;
                    }
                }
            }

            let isThicknessLengthIsLegal = checkSpecsLengthIsLegal(cargoThickness, 1, 1)
            if (!isThicknessLengthIsLegal) {
                return false
            }
        }
    }

    if (cargoWidth != null) {
        if (cargoWidth.indexOf('-') != -1) {
            if (cargoWidth.split('-').length != 2) {
                return false
            } else {
                let start = cargoWidth.split('-')[0]
                let end = cargoWidth.split('-')[1]
                if (start != '') {
                    let isWidthIsLegal = checkSpecsIsLegal(1, start, 1)
                    if (!isWidthIsLegal) {
                        return false
                    } else {
                        let isWidthLengthIsLegal = checkSpecsLengthIsLegal(1, start, 1)
                        if (!isWidthLengthIsLegal) {
                            return false
                        }
                    }
                } else {
                    return false
                }

                if (end != '') {
                    let isWidthIsLegal = checkSpecsIsLegal(1, end, 1)
                    if (!isWidthIsLegal) {
                        return false
                    } else {
                        let isWidthLengthIsLegal = checkSpecsLengthIsLegal(1, end, 1)
                        if (!isWidthLengthIsLegal) {
                            return false
                        }
                    }
                } else {
                    return false
                }
            }
        } else {
            for (let i = 0; i < cargoWidth.length; i++) {
                k = strTemp.indexOf(cargoWidth.charAt(i));

                if (k == -1) {
                    return false;
                }
            }
            let isWidthLengthIsLegal = checkSpecsLengthIsLegal(1, cargoWidth, 1)
            if (!isWidthLengthIsLegal) {
                return false
            }
        }
    }

    if (cargoLength != null) {
        if (cargoLength.indexOf('-') != -1) {
            if (cargoLength.split('-').length != 2) {
                return false
            } else {
                let start = cargoLength.split('-')[0]
                let end = cargoLength.split('-')[1]
                if (start != '') {
                    let isLengthIsLegal = checkSpecsIsLegal(1, 1, start)
                    if (!isLengthIsLegal) {
                        return false
                    } else {
                        let isCargoLengthLengthIsLegal = checkSpecsLengthIsLegal(1, 1, start)
                        if (!isCargoLengthLengthIsLegal) {
                            return false
                        }
                    }
                } else {
                    return false
                }

                if (end != '') {
                    let isLengthIsLegal = checkSpecsIsLegal(1, 1, end)
                    if (!isLengthIsLegal) {
                        return false
                    } else {
                        let isCargoLengthLengthIsLegal = checkSpecsLengthIsLegal(1, 1, end)
                        if (!isCargoLengthLengthIsLegal) {
                            return false
                        }
                    }
                } else {
                    return false
                }
            }
        } else {
            for (let i = 0; i < cargoLength.length; i++) {
                l = strTemp.indexOf(cargoLength.charAt(i));
                let a = 0
                if (l == -1) {
                    if (cargoLength == 'c' || cargoLength == 'C') {
                        a = a + 1
                    } else {
                        return false;
                    }
                }
            }
            let isCargoLengthLengthIsLegal = checkSpecsLengthIsLegal(1, 1, cargoLength)
            if (!isCargoLengthLengthIsLegal) {
                return false
            }
        }
    }

    return true;
}

const getSelSpecs = (param) => {
    if (param.cargoThickness != "") {
        let index = param.cargoThickness.indexOf("-");
        if (index >= 0) {
            param.modelHType = 20;
            let spList = param.cargoThickness.split("-");
            param.modelHStrat = spList[0];
            param.modelHEnd = spList[1];
            param.cargoThickness = undefined;
        } else {
            param.modelHType = 10;
            param.modelH = param.cargoThickness;
        }
    } else {
        param.modelHType = 10;
    }

    if (param.cargoWidth != "") {
        let index = param.cargoWidth.indexOf("-");
        if (index >= 0) {
            param.modelKType = 20;
            let spList = param.cargoWidth.split("-");
            param.modelKStrat = spList[0];
            param.modelKEnd = spList[1];
            param.cargoWidth = undefined;
        } else {
            param.modelKType = 10;
            param.modelK = param.cargoWidth;
        }
    } else {
        param.modelKType = 10;
    }

    if (param.cargoLength != "") {
        let index = param.cargoLength.indexOf("-");
        if (index >= 0) {
            param.modelCType = 20;
            let spList = param.cargoLength.split("-");
            param.modelCStrat = spList[0];
            param.modelCEnd = spList[1];
            param.cargoLength = undefined;
        } else {
            param.modelCType = 10;
            param.modelC = param.cargoLength;
        }
    } else {
        param.modelCType = 10;
    }

    return param
}

const checkSpecsLengthIsLegal = (cargoThickness, cargoWidth, cargoLength) => {
    let index = cargoThickness.toString().indexOf(".");

    if (index == -1) {
        if (cargoThickness.length > paramLength.cargoThickness) {
            return false;
        }
    }

    if (index > paramLength.cargoThickness) {
        return false;
    }

    if (cargoWidth != null && cargoWidth.length > paramLength.cargoWidth) {
        return false;
    }

    if (cargoLength != null && cargoLength.length > paramLength.cargoLength) {
        return false;
    }

    return true;
}

const getCargoLength = (cargoLength) => {
    if (cargoLength == null) {
        return 'C';
    } else {
        if (cargoLength == 0) {
            return 'C';
        } else {
            if (cargoLength > 10000) {
                return cargoLength / 1000 + 'm'
            } else {
                return cargoLength
            }
        }
    }
}

const formatCargoSpecs = (thickness, width, length) => {
    if (thickness == null || thickness == '') {
        thickness = 0
    }

    if (width == null || width == '') {
        width = 0
    }
    let thickFormat = parseFloat(thickness)
    let widthFormat = parseFloat(width)

    return thickFormat + 'x' + widthFormat + 'x' + getCargoLength(length);
}

const getQualityGrade = (qualityGrade) => {
    if (qualityGrade == 10) {
        return '一级'
    } else if (qualityGrade == 20) {
        return '二级'
    } else if (qualityGrade == 30) {
        return '三级'
    } else {
        return ''
    }
}

const checkRefThicknessIsLegal = (refThickness) => {
    let strTemp = "0123456789.";
    let dotCount = 0;
    let j = -1;

    if (refThickness != null) {
        for (let i = 0; i < refThickness.length; i++) {
            j = strTemp.indexOf(refThickness.charAt(i));

            if (j == -1) {
                return false;
            }

            if (refThickness.charAt(i).indexOf(".") != -1) {
                dotCount++;

                if (dotCount > 1) {
                    return false;
                }
            }
        }
    }

    return true;
}

const checkRefThicknessLengthIsLegal = (refThickness) => {
    if (refThickness != null) {
        let index = refThickness.toString().indexOf(".");

        // 没有小数点3位
        if (index == -1) {
            if (refThickness.length > paramLength.refThickness) {
                return false;
            }
        }

        // 有小数点3位
        if (index > paramLength.refThickness) {
            return false;
        } else {
            return true;
        }
    }

    return true
}

const checkReceivedAmountIsLegal = (receivedAmount) => {
    let strTemp = "0123456789";
    let j = -1;

    for (let i = 0; i < receivedAmount.length; i++) {
        j = strTemp.indexOf(receivedAmount.charAt(i));

        if (j == -1) {
            return false;
        }
    }

    return true;
}

const checkReceivedWeightIsLegal = (receivedWeight) => {
    let strTemp = "0123456789.";
    let dotCount = 0;
    let j = -1;

    if (receivedWeight != null) {
        if (receivedWeight == '.') {
            return false;
        } else {
            let weight = receivedWeight.toString()
            for (let i = 0; i < weight.length; i++) {
                j = strTemp.indexOf(weight.charAt(i));

                if (j == -1) {
                    return false;
                }

                if (weight.charAt(i).indexOf(".") != -1) {
                    dotCount++;

                    if (dotCount > 1) {
                        return false;
                    }
                }
            }
        }
    } else {
        return false;
    }

    return true;
}

const checkReceivedWeightLengthIsLegal = (receivedWeight) => {
    let index = receivedWeight.toString().indexOf(".");

    // 没有小数点6位
    if (index == -1) {
        if (receivedWeight.length > paramLength.receivedWeight) {
            return false;
        }
    }

    // 有小数点6位
    if (index > paramLength.receivedWeight) {
        return false;
    } else {
        return true;
    }
}

const checkCurrentWeightLengthIsLegal = (currentWeight) => {
    let index = currentWeight.toString().indexOf(".");

    if (index == -1) {
        if (currentWeight.toString().length > paramLength.lvWeight) {
            return false;
        }
    }

    if (index > paramLength.lvWeight) {
        return false;
    } else {
        return true;
    }
}

const checkPIdIsNull = (pId, isMachine) => {
    if (!isMachine) {
        if (pId == undefined || pId == null) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

const getPosition = (wcode, acode, pcode) => {
    if (wcode == '' && acode == '' && pcode == '') {
        return '请选择';
    } else if (wcode != '' && acode == '' && pcode == '') {
        return wcode;
    } else if (wcode != '' && acode != '' && pcode == '') {
        return wcode + "/" + acode;
    } else if (wcode != null && acode != null && pcode != null) {
        return wcode + "/" + acode + "/" + pcode;
    } else if (wcode != null && acode != null) {
        return wcode + "/" + acode;
    } else if (wcode != null) {
        return wcode;
    }
}

const getPositionDef = (wcode, acode, pcode) => {
    if (wcode != null && acode != null && pcode != null) {
        return wcode + "/" + acode + "/" + pcode;
    } else if (wcode != null && acode != null) {
        return wcode + "/" + acode;
    } else if (wcode != null) {
        return wcode;
    }
}

const isAllEmpty = (str) => {
    if (str == null || str == undefined || str == '') {
        return true
    } else {
        return false
    }
}
const isEmpty = (str) => {
    if (str == null || str == undefined) {
        return true
    } else {
        return false
    }
}

const sendBarCode = (val) => {
    if (val.indexOf('G#') != -1) {
        val = val.split('G#')
        return val[1]
    } else {
        if (val.indexOf('P#') != -1) {
            val = val.split('P#')
            return val[1]
        } else {
            return val
        }
    }
}

const isPhone = (val) => {
    var myreg = /^(13[0-9]{9})|(15[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/; // /^[1][3,4,5,7,8][0-9]{9}$/;
    if (!myreg.test(val)) {
        return false
    } else {
        return true
    }
}

// 不超过位数返回true
const checkNumLength = (num, intCount, dotCount) => {
    let index = num.toString().indexOf(".");

    if (index == -1) {
        if (num.length > (intCount - dotCount)) {
            return false;
        }
    }

    if (index > (intCount - dotCount)) {
        return false;
    } else {
        return true;
    }
}

const cancelStr = (str, iscancel) => {
    if (iscancel) {
        return '取消' + str
    } else {
        return str
    }
}

// double -> true
const checkDouble = (num) => {
    let strTemp = "0123456789.";
    let dotCount = 0;
    let j = -1;

    for (let i = 0; i < num.length; i++) {
        j = strTemp.indexOf(num.charAt(i));

        if (j == -1) {
            return false;
        }

        if (num.charAt(i).indexOf(".") != -1) {
            dotCount++;

            if (dotCount > 1) {
                return false;
            }
        }
    }

    return true;
}

const messageContent = {
    // success
    editSuccess: '修改成功',
    addSuccess: '添加成功',
    deleteSuccess: '删除成功',
    receiveSuccess: '收货成功',
    moveSuccess: '移位成功',
    sendNotifySuccess: '发料成功',
    checkInstockSuccess: '验收成功',
    weightSuccess: '称重成功',
    takeGoodsSuccess: '提货成功',
    qualityTestSuccess: '质检成功',
    submitSuccess: '提交成功',
    confirmSuccess: '确认成功',


    // is
    isDelete: '是否删除？',
    isReceiveConfirm: '是否确认收货？',
    isMoveConfirm: '是否确认移位吗？',
    isSendNotifyConfirm: '是否确认发料？',
    isInstockConfirm: '是否确认验收？',
    isWeightConfirm: '是否确认称重？',
    isTakeGoodsConfirm: '是否确认提货？',
    isQualityTestConfirm: '是否确认质检？',

    // legal
    specsLegal: '规格无效，请重新输入',
    weightLegal: '重量格式不正确',
    refThicknessLegal: '参考厚度无效，请重新输入',
    receivedAmountLegal: '抄码件数无效，请重新输入',
    receivedWeightLegal: '抄码重量无效，请重新输入',
    cargoNumberLegal: '物料号无效，请确认',

    // size
    specsSize: '规格过大，请重新输入',
    tscNumberSize: '钢卷号过长，请重新输入',
    refThicknessSize: '参考厚度过长，请重新输入',
    receivedAmountSize: '抄码件数过大，请重新输入',
    receivedWeightSize: '抄码重量过大，请重新输入',
    remarksSize: '备注过长，请重新输入',

    // typ
    tscNumberTyp: '请输入钢卷号',
    receivedAmountTyp: '请输入抄码件数',
    receivedWeightTyp: '请输入抄码重量',
    curWeightTyp: '请输入当前实际重量',
    positionTyp: '请指定货位',
    djxTyp: '请输入对角线不合格问题说明',
    bmTyp: '请输入版面不合格问题说明',
    wxccTyp: '请输入外形尺寸不合格问题说明',
    gcTyp: '请输入公差不合格问题说明',
    pzdTyp: '请输入平整度不合格问题说明',
    qtTyp: '请输入其他不合格问题说明',

    // sel
    cargoProcessNameSel: '请选择品名',
    positionSel: '请选择货位',
    packageSel: "请选择包装",
    warehouseSel: "请选择移位仓库",
    positionMoveSel: "请选择移位货位",
    productSel: "请选择物料",
    weightItemSel: '请选择称重货品',
    weightMachineSel: '请选择称重设备',
    qualityTypeSel: '请选择质检类型',
    qualityGradeSel: '请选择质检等级',

    // weight
    receiveConfirmUnWeighted: '存在未称重的物料',
    reweight: '请先称重',
    overWeight: '误差超过3‰，请重新称重',
    overWeightContinue: '误差超过3‰，是否继续？',

    // other
    overCargoNumber: '存在多个物料号，请确认',
    noneCargoNumber: '未搜索到对应物料号，请重新扫码',
    noneNotifyDetail: '无发料明细',
}

// 跳转页面
const routerName = {
    receiveDetail: 'receiveDetail',                 // 加工收货明细
    weighPage: 'weighPage',                         // 称重
    receiveInfo: 'receiveInfo',                     // 加工收货详情
    ProcessNotifyDetail: 'ProcessNotifyDetail',     // 加工待发料明细
    CheckInstockDetail: 'CheckInstockDetail',       // 验收入库明细
    TakeGoodsDetail: 'TakeGoodsDetail',             // 提货出库明细
    QualityTestInfo: 'QualityTestInfo',             // 质量测试
    QualityTest: 'QualityTest',                     // 质量测试扫码
    Home: 'Home',                                   // 主页
}

// 刷新跳转
const flushName = {
    curReceiveDetail: 'curReceiveDetailFlush',      // 加工收货明细
    curReceive: 'curReceiveFlush',                  // 加工收货index
    cargoMove: 'cargoMovePage',                     // 加工移位index
    processNotify: 'processNotifyIndexFlush',       // 加工待发料index
    checkInstock: 'checkInstockIndexFlush',         // 验收入库index
    checkInstockDetail: 'checkInstockDetailFlush',  // 验收入库明细
    takeGoodsDetail: 'takeGoodsDetailFlush',        // 加工提货明细
    takeGoods: 'takeGoodsIndexFlush',               // 加工提货index
}

const resCode = {
    success: '200',
}

const paramLength = {
    tscNumberLength: 20,
    receivedAmount: 2,
    receivedWeight: 6,
    refThickness: 3,
    cargoThickness: 3,
    cargoWidth: 4,
    cargoLength: 4,
    remarks: 300,
    lvWeight: 7,
}

const priorityLevelVal = {
    normal: '',
    normalVal: 10,
    urgent: '（加急）',
    urgentVal: 20,
    emergent: '（紧急）',
    emergentVal: 30,
}

export {
    cancelStr,
    isPhone,
    checkNumLength,
    checkDouble,
    checkSpecsIsLegal,
    checkSpecsLengthIsLegal,
    messageContent,
    getCargoLength,
    formatCargoSpecs,
    routerName,
    flushName,
    checkRefThicknessIsLegal,
    checkRefThicknessLengthIsLegal,
    isAllEmpty,
    isEmpty,
    checkReceivedAmountIsLegal,
    resCode,
    paramLength,
    checkReceivedWeightIsLegal,
    checkReceivedWeightLengthIsLegal,
    checkPIdIsNull,
    getPosition,
    priorityLevelVal,
    getPositionDef,
    checkCurrentWeightLengthIsLegal,
    getSelSpecs,
    checkSpecsIsSplit,
    getQualityGrade,
    sendBarCode,
}
